var _circle, _path, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgNoComments = function SvgNoComments(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 146,
    height: 146,
    fill: "none"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 73,
    cy: 73,
    r: 72.5,
    fill: "#FCFCFF",
    stroke: "#EEF0FD"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#no-comments_svg__a)",
    fillRule: "evenodd",
    d: "M56.126 49.984c4.94-.65 9.976-.984 15.089-.984 5.112 0 10.148.335 15.087.984 4.782.628 8.127 4.84 8.127 9.59v3.342c2.17 1.228 3.571 3.6 3.571 6.23v10.329c0 3.634-2.686 6.784-6.355 7.087-.263.022-.525.042-.788.062v5.76c0 .732-.435 1.39-1.102 1.67a1.77 1.77 0 0 1-1.946-.391l-6.622-6.704c-3.02-.019-6.013-.153-8.975-.397a6.783 6.783 0 0 1-1.39-.263l-9.06 9.171a1.77 1.77 0 0 1-1.945.392 1.808 1.808 0 0 1-1.103-1.67V84.48a114.64 114.64 0 0 1-2.588-.31C51.344 83.54 48 79.329 48 74.58V59.574c0-4.75 3.344-8.963 8.126-9.591Zm11.59 34.347a7.223 7.223 0 0 1-1.859-4.856v-10.33c0-3.628 2.678-6.776 6.343-7.084a116.189 116.189 0 0 1 18.657-.065v-2.422c0-3.066-2.14-5.627-5.015-6.005-4.787-.63-9.669-.954-14.627-.954-4.959 0-9.841.325-14.629.954-2.875.378-5.015 2.94-5.015 6.006v15.004c0 3.066 2.14 5.628 5.015 6.006 1.352.177 2.712.33 4.08.46a1.8 1.8 0 0 1 1.62 1.8v6.983l5.43-5.497ZM81.929 65.27c-3.178 0-6.324.133-9.433.395-1.722.144-3.067 1.639-3.067 3.481v10.33c0 1.352.733 2.53 1.804 3.108.38.205.807.337 1.27.375 3.107.257 6.25.388 9.426.388.473 0 .927.19 1.262.53l4.095 4.144v-3.085c0-.956.735-1.746 1.677-1.804.8-.05 1.597-.107 2.391-.172 1.725-.143 3.075-1.64 3.075-3.484v-10.33c0-1.568-.983-2.894-2.333-3.334a3.24 3.24 0 0 0-.734-.147c-3.11-.261-6.256-.395-9.433-.395Z",
    clipRule: "evenodd"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "no-comments_svg__a",
    x1: 48,
    x2: 54.334,
    y1: 49,
    y2: 101.289,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4E61ED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9662DB"
  })))));
};
export default SvgNoComments;